import { DataConnectionList } from "@encoo-web/encoo-ui";
import { createModel } from "nyax";
import { DataConnectionQuery } from "src/models/dataConnection";
import { DataConnectionListEntityModel } from "src/store/models/entity/dataConnection/listEntity";
import { createUIListV2Model } from "src/store/models/ui/_shared";

export const DataConnectionListModel = createModel(
  class extends createUIListV2Model<DataConnectionList, DataConnectionQuery>({
    setItems: (getContainer, items) =>
      getContainer(DataConnectionListEntityModel).actions.setItems.dispatch(
        items
      ),
    getItems: (getContainer) =>
      getContainer(DataConnectionListEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(DataConnectionListEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initial: async (payload: DataConnectionQuery) => {
          this._initial({
            initialAction: (pageIndex: number, pageSize: number) =>
              this.dependencies.serviceClient.dataConnection.getConnectionList({
                ...payload,
                pageIndex,
                pageSize,
              }),
          });
        },
      };
    }
  }
);
